// extracted by mini-css-extract-plugin
export var rightPanelOpenOld = "_a2-0";